import { render, staticRenderFns } from "./diseaseNextDetail.vue?vue&type=template&id=51bb79f3&scoped=true&"
import script from "./diseaseNextDetail.vue?vue&type=script&lang=js&"
export * from "./diseaseNextDetail.vue?vue&type=script&lang=js&"
import style0 from "./diseaseNextDetail.vue?vue&type=style&index=0&id=51bb79f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bb79f3",
  null
  
)

export default component.exports